import { YardPropertiesService } from './../../../../../yard-properties.service';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { NgModel, NgForm, UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { WeighingType } from './../model/weighing-type.enum';
import { LeaveRegistration } from './../model/out/leave-registration';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Transport } from '../model/Transport';
import { Check } from '../model/Check';
import { CheckState } from '../model/CheckState.enum';
import { RegisterLeaveService } from '../service/register-leave.service';
import { TranslationService } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';
import { AutoWeighingService } from '../../../../../legacy/auto-weighing/auto-weighing.service';
import { AreaGate } from '../model/areaGate';

interface IConfirmCallback {
  ();
}

export interface RegisterLeaveDialogData {
  transportId: number;
  callback: IConfirmCallback;
}

@Component({
  selector: 'app-register-leave',
  templateUrl: './register-leave.component.html',
  styleUrls: ['./register-leave.component.scss']
})
export class RegisterLeaveComponent implements OnInit {

  @ViewChild('weighForm') weighForm: NgForm;

  transport = new Transport();
  isLoading = false;

  clientParameters = TMCClientParameters;
  typeOptions: WeighingType[] = [];

  allowExitDespiteOfRuleViolationEnabled = false;
  allowExitDespiteOfRuleViolationFormGroup = new FormGroup({});


  areaGates = new Array<AreaGate>();
  selectedAreaGate: AreaGate = null;

  constructor(
    public dialogRef: MatDialogRef<RegisterLeaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegisterLeaveDialogData,
    public configurationService: AppClientConfigurationService,
    private leaveService: RegisterLeaveService,
    public translationService: TranslationService,
    private autoWeighingService: AutoWeighingService,
    public yardPropertiesService: YardPropertiesService) {

    for (const t of Object.keys(WeighingType)) {
      this.typeOptions.push(WeighingType[t]);
    }

    this.allowExitDespiteOfRuleViolationFormGroup.addControl('allowExitDespiteOfRuleViolation', new FormControl(false, []));
    this.allowExitDespiteOfRuleViolationFormGroup.valueChanges.subscribe(
      v => {
        this.transport.allowExitDespiteOfRuleViolation = this.allowExitDespiteOfRuleViolationFormGroup.controls['allowExitDespiteOfRuleViolation'].value;
      }
    );
  }

  ngOnInit() {
    this.leaveService.getTransport({ id: this.data.transportId }).subscribe(
      response => {
        this.transport = response;
        this.transport.autoWeightSource = this.yardPropertiesService.getLeaveType();
        const defaultType = this.yardPropertiesService.getLeaveScaleKey();
        if (defaultType != null && defaultType.length > 0) {
          this.transport.weighingType = WeighingType[defaultType];
        }
        this.allowExitDespiteOfRuleViolationEnabled = this.transport.declineLeaveCauses?.length > 0 &&
          this.configurationService.isPropertyTrue('outboundcheck.allow-exit-despite-of-rule-violations.enabled', true);
      }, error => {
        console.error(error);
        this.dialogRef.close();
      });

      this.leaveService.getAreaGates().subscribe(gates => {
        this.areaGates = gates;
        if (this.areaGates.length > 0) {
          this.selectedAreaGate = this.areaGates[0];
        }
      });
  }


  cancelDialog(): void {
    this.dialogRef.close();
  }

  isOk(check: Check) {
    return check.state === CheckState.OK;
  }

  isWarning(check: Check) {
    return check.state === CheckState.WARN;
  }

  isFailed(check: Check) {
    return check.state === CheckState.FAILED;
  }

  checksExist(transport: Transport): boolean {
    return transport != null && transport.checks != null && transport.checks.length > 0;
  }

  cancel() {
    this.dialogRef.close();
  }

  decline() {
    this.isLoading = true;

    const lr = new LeaveRegistration();
    lr.transportId = this.transport.id;
    lr.weighingType = this.transport.weighingType;
    lr.weight = this.transport.weight;
    lr.allowExitDespiteOfRuleViolation = this.transport.allowExitDespiteOfRuleViolation;
    lr.areaGateId = this.selectedAreaGate?.id;

    this.leaveService.decline(lr).subscribe(
      response => {
        this.dialogRef.close();
        this.data.callback();
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  isDeclineDisabled() {
    if (this.isLoading) {
      return true;
    }
    return false;
  }

  accept() {
    this.isLoading = true;

    const lr = new LeaveRegistration();
    lr.transportId = this.transport.id;
    if (this.isWeighingActive()) {
      lr.weighingType = this.transport.weighingType;
      lr.weight = this.transport.weight;
    } else {
      lr.weighingType = null;
      lr.weight = null;
    }
    lr.allowExitDespiteOfRuleViolation = this.transport.allowExitDespiteOfRuleViolation;
    lr.areaGateId = this.selectedAreaGate?.id;
    this.leaveService.accept(lr).subscribe(
      response => {
        this.dialogRef.close();
        this.data.callback();
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  isAcceptDisabled(): boolean {
    if (this.isLoading) {
      return true;
    }

    if (this.isLoading) {
      return true;
    }

    if (this.isWeighingActive()) {
      if (this.weighForm && this.weighForm.invalid) {
        return true;
      }
    }
    if (!this.transport.allowExitDespiteOfRuleViolation && this.transport.checks != null)  {
      let result = false;
      this.transport.checks.forEach((check) => {
        if(this.isFailed(check)) {
          result = true;
        }
      });
      if(result) {
        return result;
      }
    }
    return false;
  }

  isWeighingTypeRequired(): boolean {
    return this.transport.weight != null && this.transport.weight > 0;
  }

  descriptionExists(check: Check) {
    const description: string = this.translationService.translate(check.descriptionDictionaryKey);
    return typeof description !== 'undefined' && description !== null && description.length > 0;
  }

  showValuePositiveIntegerError(ctrl: NgModel) {
    return ctrl.touched && ctrl.hasError('positiveInteger');
  }

  public isWeighingActive(): boolean {
    return this.yardPropertiesService.isWeighingLeaveEnabled() &&
      this.yardPropertiesService.isWeighingEnabled();
  }

  public readWeight() {
    this.autoWeighingService.readWeight(this.transport.autoWeightSource).subscribe(result => {
      this.transport.autoWeight = result.weight;
      this.transport.weight = this.transport.autoWeight;
    });
  }

  public isAutoWeighingVisible(): boolean {
    return this.transport != null && this.transport.autoWeightSource != null && this.transport.autoWeightSource.length > 0;
  }

}
